<div class="busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

  <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
    <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
  </div>

  <div *fesListView="let filteredUsers of users">
    <table class="table table-striped table-bordered table-sm">
      <thead>
        <tr>
          <th fesSortField="email">Email</th>
          <th fesSortField="fullName">Name</th>
          <th fesSortField="phone">Phone</th>
          <th fesSortField="role">Role</th>
          <th fesSortField="loginFailCnt">Login Fails</th>
          <th style="text-align: center">
            <button class="new-user-btn btn btn-secondary" (click)="editUser(null)">
            <i class="fa fa-plus-square"></i> new
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input fesFilterField="email" class="small w-100"/>
          </td>
          <td>
            <input fesFilterField="fullName" class="small w-100"/>
          </td>
          <td>
            <input fesFilterField="phone" class="small w-100"/>
          </td>
          <td>
            <input fesFilterField="role" class="small w-100"/>
          </td>
          <td>
            <input fesFilterField="loginFailCnt" class="small w-100"/>
          </td>
          <td></td>
        </tr>
        <tr *ngFor="let user of filteredUsers">
          <td>{{user.email}}</td>
          <td>{{user.fullName}}</td>
          <td>{{user.phone}}</td>
          <td>{{user.role}}</td>          
          <td>{{user.loginFailCnt}}</td>
          <td class="text-center align-middle text-nowrap">
            <div class="flex flex-row">
              <a class="mr-1" href="javascript:false;" (click)="editUser(user)">edit</a>
              <div class="btn-group p-0 m-0" dropdown>
                <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle class="dropdown-toggle" aria-controls="dropdown-edit-options">
                  <span class="caret"></span>
                </a>
                <ul style="z-index:9999999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu class="p-2 dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="edit-options-btn">
                  <li role="menuitem"><button class="btn btn-danger" (click)="deleteUser(user)">Delete</button></li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      
    </table>
  </div>     
</div>